export default {
    init() {

     var self = this


     this.$body = document.querySelector('body')
     this.$header = document.querySelector('#main-header')
     this.$headerHeight = (this.$header.clientHeight) * 2
     this.headerSticky = true
     this.lastScrollTop = 0
     this.postsChanger()


     $(window).scroll( function(){
         self.headerStickyNav()

         if ($('#banner-slider').length){
             self.headerBg()
         }
     })

    //  if (!$('#banner-slider').length){
    //      this.$body.classList.add('sticky-bg')
    //  }

    },

    postsChanger(){


    },

    headerBg(){
        var self = this

        let scrollAmount = $(window).scrollTop()

        // Add BG to sticky header
        if (scrollAmount > this.$headerHeight + 20){
            this.$body.classList.add('sticky-bg')
        } else {
            this.$body.classList.remove('sticky-bg')
        }
    },

    headerStickyNav(){

        var self = this

        let scrollAmount = $(window).scrollTop()

        // Hide and show sticky header
        if (scrollAmount > this.$headerHeight && scrollAmount > this.lastScrollTop){
            if (this.headerSticky === false){
                this.$body.classList.add('no-sticky')
                this.$body.classList.remove('logo-active')
                this.headerSticky = true
            }
        } else if (scrollAmount < this.$headerHeight || scrollAmount < this.lastScrollTop) {
            if (this.headerSticky === true){
                this.$body.classList.remove('no-sticky')
                this.$body.classList.add('logo-active')
                this.headerSticky = false
            }
        }

        this.lastScrollTop = scrollAmount

    },
}



// WEBPACK FOOTER //
// ./scripts/routes/sticky.js